// import hm from '../Images/H.png'
import PIJET from "../Images/pijet.png"
import Picto from "../Images/pictofest.png"
export const Project = [
  {
    name: "Pictofest Platform",
    image: Picto,
    desc: "Developed of a comprehensive platform serving as both an event management system and a voting platform",
    link: "https://www.pictofest.in/",
  },
  {
    name: "PIJET",
    image: PIJET,
    desc: "Designed and developed a dynamic and user-friendly website and CMT for the International Journal of Engineering and Technology",
    link: "https://pijet.org/",
  },
  {
    name: "HireMate",
    image:
      "https://img.freepik.com/free-vector/recruit-agent-analyzing-candidates_74855-4565.jpg?w=1060&t=st=1703961147~exp=1703961747~hmac=02a9b7769c4af77e2c69ce6f10185aef2f411d738e20602e8634f751dc1b7348",
    desc: "Userfriendly LLM-based website which automates the work of HR using AI and enhances the job description given by HR and scores the original description",
    link: "https://github.com/swarajgosavi/LLM_Bankathon",
  },
  {
    name: "Forexprophet",
    image:
      "https://img.freepik.com/free-vector/currency-exchange-service-monetary-transfer-changing-dollar-euro-buying-selling-foreign-money-golden-coins-with-eu-us-currency-symbols-vector-isolated-concept-metaphor-illustration_335657-2818.jpg?w=740&t=st=1703878465~exp=1703879065~hmac=fda557dbb83d2289085cdf8af3d77fe4a6d2129a0a6e6544e51afa886341448e",
    desc: "Website which predicts currency exchange rates using Arima and Prophet model",
  },
];